'use client';
import React from 'react';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import Product from '@models/product';
import ProductCollectionList from '@repo/ui/src/components/ProductCollectionList';
import GrillCard from './_GrillCard';

interface Props {
  alternateSize: any;
  dark?: boolean;
  product: Product;
}

const AlternateSizes = ({ alternateSize, product, dark = false }: Props) => {
  const { t } = useTranslation();

  if (!alternateSize) return null;

  const altProduct = new Product(alternateSize);
  const sizes = [altProduct, product]
    .filter(Boolean)
    .sort((a, b) => (a?.price > b?.price ? -1 : 1));

  return (
    <ProductCollectionList
      items={sizes}
      activeId={product.id}
      itemsLabel={t('productDetailPageContent.sizesAvailableText', undefined, {
        default: 'sizes available',
      })}
      renderItem={(prod, selected) => (
        <GrillCard variation={prod} selected={selected} dark={dark} />
      )}
    />
  );
};

export default AlternateSizes;
